import { render, staticRenderFns } from "./cajas.vue?vue&type=template&id=3a501cc5"
import script from "./cajas.vue?vue&type=script&lang=js"
export * from "./cajas.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports